import { faker } from '@faker-js/faker';
import {
  ClinicalTrialDetailType,
  ClinicalTrialType,
} from '@dynamika-shared/types/clinicalTrials';
import { StudyStatusEnum } from '@dynamika-shared/types/status';
import { mockPaginate } from './paginate';
import { createRandomCohortList } from './cohorts';
import { createRandomModalityLabelList } from './labels';
import { InventoryState } from '@restore/inventory/inventory.types';
import { SiteConfigurationType } from '@dynamika-shared/types/site';
import { CohortType } from '@dynamika-shared/types/cohorts';

export function createRandomClinicalTrial(id?: string): ClinicalTrialType {
  return {
    id: id ?? faker.string.uuid(),
    name: faker.company.name(),
    sponsorName: faker.company.name(),
    endDate: faker.date.past().toISOString(),
    startDate: faker.date.past().toISOString(),
    description: faker.lorem.paragraph(),
    cohorts: createRandomCohortList(11),
    status: faker.helpers.arrayElement([
      StudyStatusEnum.cancelled,
      StudyStatusEnum.closeUp,
      StudyStatusEnum.completed,
      StudyStatusEnum.maintenance,
      StudyStatusEnum.onHold,
      StudyStatusEnum.draft,
    ]),
  };
}
export function createRandomClinicalTrialDetail(
  id: string,
  inventory?: InventoryState['inventory'],
  status?: StudyStatusEnum,
  sites?: SiteConfigurationType[],
  cohorts?: CohortType[],
): ClinicalTrialDetailType {
  const randomStartDate = faker.date.past().toISOString();
  const randomEndDate = faker.date
    .between({ from: randomStartDate, to: new Date() })
    .toISOString();
  return {
    sites: sites || [],
    id,
    code: '',
    name: faker.company.name(),
    sponsorId: inventory?.sponsors[0].id || faker.string.uuid(),
    dataStorageLocationId: inventory?.locations[0].id || faker.string.uuid(),
    endDate: faker.date.past().toISOString(),
    startDate: faker.date.past().toISOString(),
    description: faker.lorem.paragraph(),
    cohorts: cohorts || createRandomCohortList(11),
    status: status || faker.helpers.arrayElement([
      StudyStatusEnum.cancelled,
      StudyStatusEnum.closeUp,
      StudyStatusEnum.completed,
      StudyStatusEnum.maintenance,
      StudyStatusEnum.onHold,
      StudyStatusEnum.draft,
    ]),
    iagStudyEmail: faker.internet.email(),
    dashboardUrl: faker.internet.url(),
    ctGovLink: faker.internet.url(),
    eudraCt: faker.internet.url(),
    phase: inventory?.phases[0].id || faker.lorem.word(),
    therapeuticArea: inventory?.therapeuticAreas[0].id || faker.lorem.words(2),
    disease: inventory?.diseases[0].id || faker.lorem.words(2),
    drugMolecule: faker.lorem.word(),
    firstPatientVisit: randomStartDate,
    lastPatientVisit: randomEndDate,
    siteHypothesis: faker.number.int(100),
    patientHypothesis: faker.number.int(100),
    visitHypothesis: faker.number.int(100),
    labelGroups: createRandomModalityLabelList(10),
    questionnaires: []
  };
}

export function createRandomClinicalTrialsList(
  count: number
): ClinicalTrialType[] {
  return faker.helpers.multiple(createRandomClinicalTrial, { count });
}
export function createPaginatedRandomClinicalTrialsList(
  count: number,
  args = { page: 1, size: 10 }
) {
  const clinicalTrialsList = createRandomClinicalTrialsList(count);
  return mockPaginate(clinicalTrialsList, args);
}
